import React from "react";
import "../../../css/DesignSystem/Buttons/ButtonOutlinedRed.css";

const ButtonOutlinedRed = ({ children, onClick, disabled, buttonText }) => {
  return (
    <button
      className={`button-outlined-red ${disabled ? "disabled" : ""}`}
      onClick={onClick}
      disabled={disabled}
    >
      <div className="Button-Text-Medium">{buttonText}</div>
      {children}
    </button>
  );
};

export default ButtonOutlinedRed;
